import {
  ArchitectureIcon,
  BimIcon,
  DevelopmentIcon,
  SurveyIcon,
} from './PartnersIcons';
import HomeSectionAccordion from '../HomeSectionAccordion/HomeSectionAccordion';
import './style.css';

const Partners = () => {
  return (
    <section className="section partners">
      <div className="container">
        <div className="partners__wrapper">
          <HomeSectionAccordion
            id="partners"
            title="С кем мы работаем"
            summary="Сотрудничаем с компаниями, которым требуется подготовка документации и BIM-моделей по данным лазерного сканирования."
            summaryClassName="partners__text"
          >
            <div className="partners__grid">
            <article className="partners__card">
              <div className="partners__icon">
                <SurveyIcon />
              </div>
              <h2 className="partners__card-title">Геодезические компании</h2>
            </article>

            <article className="partners__card">
              <div className="partners__icon">
                <ArchitectureIcon />
              </div>
              <h2 className="partners__card-title">Архитектурные и инженерные бюро</h2>
            </article>

            <article className="partners__card">
              <div className="partners__icon">
                <BimIcon />
              </div>
              <h2 className="partners__card-title">BIM-подрядчики</h2>
            </article>

            <article className="partners__card">
              <div className="partners__icon">
                <DevelopmentIcon />
              </div>
              <h2 className="partners__card-title">Девелоперы и владельцы объектов</h2>
            </article>
            </div>
          </HomeSectionAccordion>
        </div>
      </div>
    </section>
  );
};

export default Partners;
